<div id="pdf_print_area_1" #pdf_print_area_1 class="row">
    <div class="col-lg-12 col-md-12">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>OTC Market Value Share by Category</h3>
            </div>

            <!-- FPT-ThinhLD4: [SENSE] INTAGE page Region Dropdownbox -->
            <div class="filter-section ssmm-filter even-wrapper">

                <!-- <div class="ng-section summary-section native">
                    <b>Aggregate By</b>
                    <select class="form-control filter-by-category form-basic" (change)="onOTCMarketsizeAggregateChange($event.target.value)">
                        <option value="wtd">Weekly</option>
                        <option value="mtd">Monthly</option>
                        <option value="qtd">Quarterly</option>
                        <option value="ytd">Yearly</option>
                    </select>
                </div> -->
                <single-dropdown title="Aggregate By"
                    [items]="[{value: 'wtd', name: 'Week to Date'}, {value: 'mtd', name: 'Month to Date'}, {value: 'qtd', name: 'Quarter to Date'}, {value: 'ytd', name: 'Year to Date'}]"
                    [model]="aggregateBy"
                    (change)="onOTCMarketsizeAggregateChange($event)">
                </single-dropdown>
                
                <!-- <div class="ng-section summary-section native">
                    <b>Display</b>
                    <select class="form-control filter-by-category form-basic" (change)="onOtcDisplayChannelChange($event.target.value)">
                        <option value="1">Channel Level 1</option>
                        <option value="2">Channel Level 2</option>
                    </select>
                </div> -->
                <single-dropdown title="Display"
                    [items]="[{value: '1', name: 'Channel Level 1'}, {value: '2', name: 'Channel Level 2'}]"
                    [model]="otcDisplayChannel"
                    (change)="onOtcDisplayChannelChange($event)">
                </single-dropdown>

                <div class="ng-section summary-section">
                    <b>Region</b>
                    <ng-select #ngFilterOTCRegion class="form-control filter-by-category ng-region" [searchable]="false" [virtualScroll]="true" [(ngModel)]="otcSelectedRegion[0]" [multiple]="false" [closeOnSelect]="false"
                    (remove)="onRemoveFilterOTCRegion($event)"
                    (change)="onRemoveFilterOTCRegion($event);onChangeCheckBox($event)"
                    (open)="SaveOptionValueTemp(false);onChangeCheckBox($event)"
                    (blur)="SaveOptionValueTemp(true)"
                    [clearable]="otcSelectedRegion.length > 1"
                    (add)="onAddFilterOTCRegion($event)">
                        <ng-option *ngFor="let item of summaryRegions" [value]="item"><input type="checkbox" class="cb-multi-select"/> {{item}}</ng-option>
                        <ng-template ng-footer-tmp>
                            <button type="submit" class="btn btn-primary"
                            (click)="SaveOptionValueTemp(false);ngFilterOTCRegion.close();onOtcSelectedRegionChange()">Aggregate</button>
                        </ng-template>                                
                        <ng-template ng-multi-label-tmp let-items="items">
                            <ng-container *ngFor="let item of items; index as i">
                                <ng-container *ngIf="i==0">
                                    {{item}}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="items.length > 1">
                                ...
                            </ng-container>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="ng-section summary-section">
                    <b>Package Type</b>
                    <ng-select #ngFilterPackageType class="form-control filter-by-category" [searchable]="false" [virtualScroll]="true" [(ngModel)]="otcSelectedPackageType[0]" [multiple]="false" [closeOnSelect]="false"
                    (remove)="onRemoveFilterOTCPackageType($event)"
                    (change)="onRemoveFilterOTCPackageType($event);onChangeCheckBox($event)"
                    (open)="SaveOptionValueTemp(false);onChangeCheckBox($event)"
                    (blur)="SaveOptionValueTemp(true)"
                    [clearable]="otcSelectedPackageType.length > 1"
                    (add)="onAddFilterOTCPackageType($event)">
                        <ng-option *ngFor="let item of summaryPackageTypes" [value]="item"><input type="checkbox" class="cb-multi-select"/> {{item}}</ng-option>
                        <ng-template ng-footer-tmp>
                            <button type="submit" class="btn btn-primary"
                            (click)="SaveOptionValueTemp(false);ngFilterPackageType.close();onOtcSelectedPackageTypeChange()">Aggregate</button>
                        </ng-template>                                
                        <ng-template ng-multi-label-tmp let-items="items">
                            <ng-container *ngFor="let item of items; index as i">
                                <ng-container *ngIf="i==0">
                                    {{item}}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="items.length > 1">
                                ...
                            </ng-container>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="card-body">
                <div #scroll class="market-size">
                    <table #screen class="intage-market-size">
                        <tr>
                            <th colspan="3" class="summary-row-col">Channel</th>
                            <th *ngFor="let item of categories; index as i;" [style]="'background-color:' + getCategoryColor(item)">{{getCategoryDisplayName(item)}}</th>
                        </tr>
                        <!-- // FPT-HoiLT2 [2022-12-21][SENSE][1203240599236569] INTAGE OTC formatting -->
                        <ng-container *ngFor="let channel of data; index as i;">
                            <tr *ngIf="channel.channel !== 'Other OTC'">
                                <ng-container *ngIf="i==0">
                                    <td class="first-left-col" [attr.rowspan]="data.length*2 - 2"><b>Market Size</b></td>
                                </ng-container>
                                <td rowspan="2" [class]="i == data.length - 2 ? 'last-row-td' : ''" class="second-left-col">{{channel.channel}}</td>
                                <td class="bg-row third-left-col ssmm">% vs LY</td>
                                <td class="bg-row" *ngFor="let item of categories; index as i;">
                                    <b [class]="getVsLyOfCategoryForMarketSize(channel.categories, item).indexOf('-') != -1 ? 'text-red': ''">
                                        {{getVsLyOfCategoryForMarketSize(channel.categories, item).indexOf('-') != -1 ? '': '+'}}{{getVsLyOfCategoryForMarketSize(channel.categories, item)}}
                                    </b>
                                </td>
                            </tr>
                            <tr *ngIf="channel.channel !== 'Other OTC'" [class]="i == data.length - 2 ? 'last-row' : ''">
                                <td class="third-left-col ssmm">IMP</td>
                                <td *ngFor="let item of categories; index as j;">{{getImpOfCategory(channel.categories, item)}}</td>
                            </tr>
                        </ng-container>
                        <ng-container *ngFor="let maker of marketShareData2; index as i;">
                            <ng-container *ngFor="let channel of maker.channels; index as j;">
                                <tr *ngIf="channel.channel !== 'Other OTC'">
                                    <ng-container *ngIf="j==0">
                                        <td class="first-left-col" [attr.rowspan]="maker.channels.length *2 - 2">
                                            <ng-container *ngIf="maker.logo == ''">
                                                <span class="maker-name">{{maker.maker}}</span>
                                            </ng-container>
                                            <ng-container *ngIf="maker.logo != ''">
                                                <img class="maker-logo" src="{{maker.logo}}" />
                                            </ng-container>
                                        </td>
                                    </ng-container>
                                    <td rowspan="2" class="second-left-col" [class]="j == maker.channels.length - 2 ? 'last-row' : ''">{{channel.channel}}</td>
                                    <td class="bg-row third-left-col ssmm">Share</td>
                                    <ng-container *ngFor="let item of categories; index as k;">
                                        <td class="bg-row"><b>{{getShareOfCategory(channel.categories, item)}}</b></td>
                                    </ng-container>
                                </tr>
                                <tr *ngIf="channel.channel !== 'Other OTC'" [class]="j == maker.channels.length - 2 ? 'last-row' : ''">
                                    <td class="third-left-col ssmm">Diff.LY</td>
                                    <ng-container *ngFor="let item of categories; index as k;">
                                        <td [class]="getVsLyOfCategory(channel.categories, item).indexOf('-') != -1 ? 'text-red': ''">{{getVsLyOfCategory(channel.categories, item).indexOf('-') != -1 ? '': '+'}}{{getVsLyOfCategory(channel.categories, item)}}</td>
                                    </ng-container>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </table>
                </div>
                <div class="d-flex flex-two-ends mt-4 hide-pdf-print">
                    <comment-button title1="OTC Market Value Share by Category" [screen]="screen"
                    [users]="users" [chartId]="chartId" [chatIdDependency]="[{selectedWeek, state:{aggregateBy: aggregateBy ?? 'wtd', otcDisplayChannel, otcSelectedRegion, otcSelectedPackageType}}]"></comment-button>

                    <download-button>
                        <button ngbDropdownItem (click)="exportOTCMarketSize(true)">Download PNG</button>
                        <button ngbDropdownItem (click)="exportOTCMarketSize(false)">Download CSV</button>
                        <button ngbDropdownItem (click)="downloadAsPDF('OTC Market Value Share by Category')">Download PDF</button>
                    </download-button>
                </div>                
            </div>
             <!--FPT-MyNT15 [2022/11/30][SENSE][1203444563290052] Intage OTC report add download PNG-->
            <div id="download">
                <img #canvas>
                <a #downloadLink></a>
            </div>
        </div>
    </div>
</div>
